import { BlogState } from "../types/blogTypes";
import { AnyAction } from "redux";
import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
} from "../actions/blogActions";

const initialState: BlogState = {
  blogsData: { blogs: [], totalRecords: 0, lastDoc: undefined, firstDoc: undefined },
  loading: true,
  error: null,
};

const blogReducer = (state = initialState, action: AnyAction): BlogState => {
  switch (action.type) {
    case FETCH_BLOGS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BLOGS_SUCCESS:
      return {
        ...state,
        blogsData: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_BLOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    // Handle other item-related actions here...
    default:
      return state;
  }
};

export default blogReducer;
